import { render } from "./customPagination.vue?vue&type=template&id=323298d4"
import script from "./customPagination.vue?vue&type=script&lang=js"
export * from "./customPagination.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__